import { useLocation } from "@tanstack/react-router";
import { ThemeToggle } from "@/components/layout/ThemeToggle";

const VIEW_LABELS: Record<string, string> = {
  intake: "Intake",
  review: "Review",
  followups: "Follow-ups",
  scope: "Scope",
  questions: "Questions",
  conflicts: "Conflicts",
  report: "Report",
  members: "Members",
};

interface SolutionTopBarProps {
  solutionName?: string;
}

export function SolutionTopBar({ solutionName }: SolutionTopBarProps) {
  const location = useLocation();
  const segment = location.pathname.split("/")[3] ?? "";
  const viewLabel = VIEW_LABELS[segment] ?? "";

  return (
    <header className="h-[58px] flex items-center justify-between px-6 border-b border-[var(--color-border)] bg-transparent">
      <nav aria-label="Breadcrumb" className="text-sm">
        <ol className="flex items-center gap-2 text-foreground/60">
          <li className="font-display font-semibold text-foreground">
            {solutionName ?? "Solution"}
          </li>
          {viewLabel && (
            <>
              <li aria-hidden>/</li>
              <li className="font-medium text-foreground">{viewLabel}</li>
            </>
          )}
        </ol>
      </nav>

      <div className="flex items-center gap-2">
        <ThemeToggle />
      </div>
    </header>
  );
}
